import { ITransactionSetWithSubtype } from 'types/graphqlTypes'

/**
 * Build a select option label from a transaction set + subtype
 *
 * @param item A transaction set + subtype
 * @returns a string usable as a select option label
 * @example formatOptionLabel({transactionSet: '_990'}) // '990'
 * @example formatOptionLabel({transactionSet: '_214', transactionSetSubtype: 'SCHEDULED_TRACKING'}) // '214 (scheduled tracking)'
 */
export const formatOptionLabel = (item: ITransactionSetWithSubtype): string => {
  let label = item.transactionSet.substr(1)
  if (item.transactionSetSubtype) {
    // 'SCHEDULED_TRACKING' -> 'scheduled tracking'
    label = `${label} (${item.transactionSetSubtype.toLowerCase().replace('_', ' ')})`
  }
  return label
}
